import { render, staticRenderFns } from "./ItemInput.vue?vue&type=template&id=dd11a2cc&lang=html&"
import script from "./ItemInput.vue?vue&type=script&lang=js&"
export * from "./ItemInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports